import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";
import { rolesWorkspacesApi } from "./roles-workspacesApi";
import { RoleWorkspace, CreateRoleWorkspace, UpdateRoleWorkspace } from "./roles-workspaces.interface";

export const fetchRolesWorkspaces = createAsyncThunk<
  APIResponse<RoleWorkspace[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("rolesWorkspaces/fetchRolesWorkspaces", async (_, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(rolesWorkspacesApi.endpoints.getRolesWorkspaces.initiate()).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al obtener Roles de Workspaces",
      details: data.details,
    });
  }
});

export const fetchRoleWorkspaceById = createAsyncThunk<
  APIResponse<RoleWorkspace>,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("rolesWorkspaces/fetchRoleWorkspaceById", async (id, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(rolesWorkspacesApi.endpoints.getRoleWorkspaceById.initiate(id)).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al obtener Rol de Workspace",
      details: data.details,
    });
  }
});

export const createRoleWorkspace = createAsyncThunk<
  APIResponse<RoleWorkspace>,
  CreateRoleWorkspace,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("rolesWorkspaces/createRoleWorkspace", async (data, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(rolesWorkspacesApi.endpoints.createRoleWorkspace.initiate(data)).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al crear Rol de Workspace",
      details: data.details,
    });
  }
});

export const updateRoleWorkspace = createAsyncThunk<
  APIResponse<RoleWorkspace>,
  { id: number; changes: UpdateRoleWorkspace },
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("rolesWorkspaces/updateRoleWorkspace", async ({ id, changes }, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(rolesWorkspacesApi.endpoints.updateRoleWorkspace.initiate({ id, changes })).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al actualizar Rol de Workspace",
      details: data.details,
    });
  }
});
